import type {TicketStatus, TicketPriority} from '../types/ticket';
import {PRIORITY_LABELS, PRIORITY_ORDER} from './priority';

export interface FilterOption<T extends string = string> {
	id: T;
	label: string;
}

export const STATUS_OPTIONS: FilterOption<TicketStatus>[] = [
	{id: 'open', label: 'Open'},
	{id: 'in_progress', label: 'In progress'},
	{id: 'waiting_on_customer', label: 'Waiting on customer'},
	{id: 'resolved', label: 'Resolved'},
	{id: 'closed', label: 'Closed'},
];

export const PRIORITY_OPTIONS: FilterOption<TicketPriority>[] = PRIORITY_ORDER.map(id => ({
	id,
	label: PRIORITY_LABELS[id],
}));

export const SLA_OPTIONS: FilterOption<string>[] = [
	{id: 'breached', label: 'Breached'},
	{id: 'paused', label: 'Paused'},
];

export const UNASSIGNED_OPTION: FilterOption = {
	id: '__unassigned__',
	label: 'Unassigned',
};
